export default __webpack_public_path__ + "static/media/TodayHeader.77e3f746.png";